export const staticLabelsCompare = {
  en: {
    compareProducts: "Compare Products",
    back: "Back",
    clearResults: "Clear Results",
    compare: "Compare",
  },
};
